<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFrom"
                label="Date From:"
                prepend-icon="mdi-calendar"
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="#9f09d7"
              ref="picker"
              v-model="dateFrom"
              year-icon="mdi-calendar-blank"
              prev-icon="mdi-skip-previous"
              next-icon="mdi-skip-next"
              @change="save1"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateTo"
                label="Date To:"
                prepend-icon="mdi-calendar"
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="#9f09d7"
              ref="picker"
              v-model="dateTo"
              year-icon="mdi-calendar-blank"
              prev-icon="mdi-skip-previous"
              next-icon="mdi-skip-next"
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-btn
            color="primary"
            @click="searchByDate()"
            block
            class="mt-1"
            large
            >Search</v-btn
          >
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-btn @click="exportXlsx()" class="mt-1" block large color="success"
            >Export XLSX</v-btn
          >
        </v-col>
      </v-row>
      <TransactionHistory :Transtions="Transtions" />
      <v-row
        v-if="Transtions.length > 9 || padginatonDeta.pagesTotal > 1"
        justify="center"
      >
        <v-col cols="8">
          <div class="max-width cont">
            <v-progress-circular
              v-if="loading"
              :width="3"
              :size="30"
              indeterminate
              class="loadColor"
            >
              <small>{{ value }}</small>
            </v-progress-circular>
            <v-pagination
              append-icon="mdi-calendar"
              v-model="page"
              class="my-4"
              prev-icon="mdi-skip-previous"
              next-icon="mdi-skip-next"
              :length="padginatonDeta.pagesTotal"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import TransactionHistory from "../components/TransactionHistory";
import currencyFormatter from "currency-formatter";
import dayjs from "dayjs";
import xlsx from "json-as-xlsx";

export default {
  components: { Profile: Profile, TransactionHistory },

  created() {
    this.GetTranstion();
  },
  metaInfo: {
    title: "Teller/History",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.value === 100) {
        return (this.value = 0);
      }
      this.value += 10;
    }, 1000);
  },
  computed: {
    Transtions() {
      return this.$store.state.Transactions.Transtions;
    },
    padginatonDeta() {
      return this.$store.state.Transactions.pagination;
    },
    User() {
      return this.$store.getters.getUser;
    },
    loading() {
      return this.$store.state.Transactions.loading;
    },
  },
  methods: {
    transactionName(payload) {
      if (payload == 2) return "FRSC DRIVER'S LICENSE";
      else if (payload == 3) return "REVERSAL";
      else if (payload == 4) return "NIS PAYMENT";
      else if (payload == 5) return "MANUAL CREDIT ";
      else if (payload == 6) return "BANK TRANSFER DEPOSIT";
      else if (payload == 7) return "BANK TRANSFER WITHDRAWAL";
      else if (payload == 8) return "JAMB PAYMENT";
      else if (payload == 9) return "ELECTRICITY";
      else if (payload == 10) return "AIRTIME PURCHASE ";
      else if (payload == 11) return "CABLE (TV)";
      else if (payload == 12) return "INTERNET";
      else if (payload == 13) return "PERSONAL TRANSFER";
      else if (payload == 14) return "POS CREDIT";
    },
    exportXlsx() {
      var columns = [
        {
          label: "Transaction Name",
          value: (row) => this.transactionName(row.activity),
        }, // Top level data
        {
          label: "Amount",
          value: (row) => this.DisplayCurrency(row.amount / 100),
        }, // Top level data
        {
          label: "Balance",
          value: (row) =>
            this.DisplayCurrency(row.mainBalanceAfterTransaction / 100),
        }, // Top level data
        {
          label: "Reference",
          value: (row) =>
            row.additional ? row.additional.reference || "" : "",
        }, // Top level data
        {
          label: "Application ID",
          value: (row) => (row.additional ? row.additional.appID || "" : ""),
        }, // Top level data
        {
          label: "Pay Bill TxnID",
          value: (row) =>
            row.additional ? row.additional.payBillTxnID || "" : "",
        }, // Top level data
        {
          label: "Payment Date",
          value: (row) => this.DisplayTime(row.timestamp),
        }, // Top level data
        { label: "Payment Status", value: () => "Successful" }, // Top level data
      ];

      var content = this.Transtions;
      console.log(content, "content");
      if (content.length == 0) {
        let payload = {
          status: true,
          message: "No data available",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }

      var settings = {
        sheetName: "First sheet", // The name of the sheet
        fileName: "Teller Report", // The name of the spreadsheet
        extraLength: 3, // A bigger number means that columns should be wider
      };

      var download = true; // If true will download the xlsx file, otherwise will return a buffer

      xlsx(columns, content, settings, download);
    },

    searchByDate() {
      if (this.dateTo == null || this.dateFrom == null) {
        console.log("JJ");
        return;
      }
      let payload = {
        pin: this.User.pin,
        customerID: this.User.customerID,
        page: "",
        pageSize: 50,
        dateTo: dayjs(this.dateTo).format("D-MMM-YYYY hh:mm"),
        dateFrom: dayjs(this.dateFrom).format("D-MMM-YYYY hh:mm"),
      };
      this.$store.dispatch("searchByDate", payload);
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    save1(date) {
      this.$refs.menu1.save(date);
    },
    showdialog(payload) {
      this.dialog = true;
      this.detail = payload;
    },
    GetTranstion() {
      let payload = {
        pin: this.User.pin,
        customerID: this.User.customerID,
        dateTo: dayjs()
          .add(3, "day")
          .format("D-MMM-YYYY hh:mm"),
        page: "",
        pageSize: 50,
        dateFrom: dayjs()
          .subtract(12, "month")
          .format("D-MMM-YYYY hh:mm"),
      };
      this.$store.dispatch("searchByDate", payload);
    },

    DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN",
      });
    },
    DisplayTime(payload) {
      if (payload) {
        return dayjs(payload).format("D-MMM-YYYY hh:mm");
      }
    },
  },

  watch: {
    page: function(val) {
      if (this.page != this.Currpage) {
        console.log("PP");
        if (this.dateTo == null || this.dateFrom == null) {
          this.Currpage = val;
          let payload = {
            pin: this.User.pin,
            page: val,
            pageSize: 50,
            customerID: this.User.customerID,
            dateTo:
              this.dateTo != ""
                ? dayjs(this.dateTo).format("D-MMM-YYYY hh:mm")
                : dayjs().format("D-MMM-YYYY hh:mm"),
            dateFrom:
              this.dateFrom != ""
                ? dayjs(this.dateFrom).format("D-MMM-YYYY hh:mm")
                : dayjs()
                    .subtract(1, "month")
                    .format("D-MMM-YYYY hh:mm"),
          };
          this.$store.dispatch("searchByDate", payload);
          return;
        }
        this.Currpage = val;
        let payload = {
          pin: this.User.pin,
          page: val,
          pageSize: 50,
          customerID: this.User.customerID,
          dateTo: dayjs(this.dateTo).format("D-MMM-YYYY hh:mm"),
          dateFrom: dayjs(this.dateFrom).format("D-MMM-YYYY hh:mm"),
        };
        this.$store.dispatch("searchByDate", payload);
      }
    },
  },

  data: () => ({
    dialog: false,
    page: 1,
    value: 0,
    Currpage: 1,
    menu1: false,
    menu: false,
    dateFrom: new Date(dayjs().subtract(12, "month"))
      .toISOString()
      .substr(0, 10),
    dateTo: new Date().toISOString().substr(0, 10),
    detail: {},
    pagesTotal: 27,
  }),
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody";
}
.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 0px;
  height: 700px;
  overflow: scroll;
}
.mainBody::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}
.mainBody::-webkit-scrollbar-thumb {
  background: #ad1684;
  border-radius: 10px;
}
.cen {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.cont {
  display: flex;
  justify-content: center;
  align-items: center;
}
.moni {
  font-family: AvenirLTPro-55Roman;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  color: #444444;
}
.enter {
  margin-bottom: 10px;
  height: 450px;
  overflow: scroll;
}
.enter::-webkit-scrollbar {
  display: none;
}
.card {
  padding: 20px;
  width: 600px;
  height: 500px;
  overflow: scroll;
  border-radius: 10px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11) !important;
  background-color: #ffffff;
}

.card::-webkit-scrollbar {
  display: none;
}

.bankT {
  text-align: center;
  color: #ad1684;
}
.cardR {
  margin: 10px;
  margin-left: 20px !important;
  margin-right: 20px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11) !important;
  background-color: #ffffff;
}
.RlistM {
  overflow: scroll;
}

.card::-webkit-scrollbar {
  display: none;
}
.RlistM {
  margin-right: 4px;
}
.titl {
  font-family: "AvenirLTProBook";
  width: 203px;
  height: 22px;
  font-size: 18px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  color: #000000;
  text-transform: uppercase;
}
@media only screen and (max-width: 1024px) {
  .card {
    padding: 20px;
    overflow: scroll;
    border-radius: 10px !important;
  }
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 20px;
    padding-top: 30px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
